import React, { Component } from 'react';
import { connect } from 'react-redux';
import Node from './Node'
import NodeId from './NodeId'
import Loading from '../fixedComponents/Loading'
import UserRanking from '../ranking/UserRanking'
import Iconlinks from '../ranking/Iconlinks'
import {
  setInitialPosition, fetchInitialNodes, resetClient,
  setLocale, fetchInitialMineLiked
} from '../../actions';
import ZoomSwitch from '../fixedComponents/ZoomSwitch'
import MobileDialog from './MobileDialog'
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export class Home extends Component {

  componentDidMount() {
    const { fetchInitialNodes, setInitialPosition, fetchInitialMineLiked,
      resetClient, setLocale, client } = this.props;
    const loc = cookies.get('locale')
    if(['en', 'ja'].indexOf(loc) !== -1) {
      setLocale(loc)
    }
    if(client.x['0']=== 200 && client.y['0']===200) {
      setInitialPosition(window.innerHeight, window.innerWidth, '0')
    }
    if(typeof this.props.match !== 'undefined' && this.props.match.path === '/') {
      resetClient();
      fetchInitialNodes(loc);
      if(cookies.get('api_access_token') === 'undefined' || cookies.get('api_access_token') == null) {
        return
      }
      fetchInitialMineLiked();
    }
  }

  render() {
    const { server, client } = this.props

    if (client.isLoading) {
      return <Loading />
    }

    let id = null
    if(typeof this.props.match !== 'undefined' && this.props.match.path !== '/') {
      id = this.props.match.params.id
    }
    if(id === null || typeof id === 'undefined' || id === 'null' ||
      id in client.clickedId
      || typeof client.clickedId[server.parent[id]] !== 'undefined') {
      return(
        <div>
          <Node id={server.rootId} number={String(client.rootNumber)}
            parent={String(client.rootNumber)} root={true} page={0} />
          <UserRanking />
          <Iconlinks />
          <ZoomSwitch />
          <MobileDialog />
        </div>
      )
    }
    return(
      <div>
        <NodeId id={id} />
        <UserRanking />
        <Iconlinks />
        <ZoomSwitch />
        <MobileDialog />
      </div>
    )
  }

}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

const mapDispatchToProps = {
  setInitialPosition,
  fetchInitialNodes,
  resetClient,
  setLocale,
  fetchInitialMineLiked
};

export default connect(mapStateToProps, mapDispatchToProps)(Home)



// WEBPACK FOOTER //
// ./src/components/nodes/Home.js